import anime from 'animejs/lib/anime.es.js';

// Create a nimation timeline for each component

function animateContentCard(contentCard){

	const contentCardImage = contentCard.querySelector(".aspect-ratio-image img");
	const contentCardBanner = contentCard.querySelector(".content-card__banner");
	const contentCardText = contentCard.querySelector(".content-card__text");
	const contentCardTextWrap = contentCard.querySelector(".content-card__text-wrap");

	contentCardTextWrap.style.opacity = 0

	anime.remove(contentCardImage, contentCardBanner, contentCardText, contentCardTextWrap);


	const contentCardTextHeight = contentCardText.offsetHeight + 16;
	const contentCardHeight = contentCard.offsetHeight;
	
	// Scale Image
	// Grow box height and width
	// Slide Banner up
	// Slide Text up
	
	var tl = anime.timeline({
		  easing: 'easeInOutCubic',
		  duration: 750
		});
	tl
	.add({
		targets: contentCardImage,
		scale: 1.2,
		duration: 250
	})
	.add({
		targets: contentCardTextWrap,
		height: ["0", contentCardTextHeight],
		translateY: ["105%", 0],
		paddingTop: "1rem",
		opacity: [0, 1],
		easing: 'easeInOutBack'
	}, "-=400")
}

function reverseAnimateContentCard(contentCard){

	const contentCardImage = contentCard.querySelector(".aspect-ratio-image img");
	const contentCardBanner = contentCard.querySelector(".content-card__banner");
	const contentCardText = contentCard.querySelector(".content-card__text");
	const contentCardTextWrap = contentCard.querySelector(".content-card__text-wrap");

	anime.remove(contentCardImage, contentCardBanner, contentCardText, contentCardTextWrap);

	const contentCardTextHeight = contentCardText.offsetHeight;
const contentCardHeight = contentCard.offsetHeight;
		
	var tl = anime.timeline({
		  easing: 'easeInOutQuad',
		});
	tl
	.add({
		targets: contentCardTextWrap,
		height: 0,
		translateY: 0,
		opacity: [1, 0],
		paddingTop: "0rem",
		easing: 'easeInOutCubic'
	})
	.add({
		targets: contentCardImage,
		scale: 1,
		duration: 250
	}, "-=400");
}

function setupContentCardsAnimations (){
	
	const contentCard = document.querySelectorAll(".js-content-card");
	
	if (contentCard.length > 0) {
		for (var i = 0; i < contentCard.length; i++) {
			
			const loopedContentCard = contentCard[i];
					
			contentCard[i].addEventListener('mouseenter', function() {
				animateContentCard(loopedContentCard);
			}, false);
			contentCard[i].addEventListener('mouseleave', function() {
				reverseAnimateContentCard(loopedContentCard);
			}, false);
			//contentCard[i].addEventListener('mouseleave', leaveText, false);		
		}
	}	
}

export default setupContentCardsAnimations;




// function animateButton(scale, duration, elasticity) {
//   anime.remove(buttonEl);
//   anime({
// 	targets: buttonEl,
// 	scale: scale,
// 	duration: duration,
// 	elasticity: elasticity
//   });
// }
// 
// function animateText(translateX) {
//   anime.remove(textEl);
//   anime({
// 	targets: textEl,
// 	translateY: translateX,
// 	elasticity: 300
//   });
// }
// 
// function enterButton() { animateButton(1.2, 800, 400) };
// function leaveButton() { animateButton(1.0, 600, 300) };
// 
// function enterText() { animateText(-70) };
// function leaveText() { animateText(0) };
// 
// buttonEl.addEventListener('mouseenter', enterButton, false);
// buttonEl.addEventListener('mouseleave', leaveButton, false);
// buttonEl.addEventListener('mouseenter', enterText, false);
// buttonEl.addEventListener('mouseleave', leaveText, false);

// .js-content-card

